/**
 * Block: helper-cards-general
 * V2 JS — More/Less toggle + filter tab switching
 */

export function init() {
  const block = document.querySelector('.helper-cards-general.block--v2');
  if (!block) return;

  // More/Less toggle
  // Clone each toggle to strip legacy event listeners (legacy JS also targets these)
  block.querySelectorAll('.helper-cards-general__toggle-card-text').forEach((original) => {
    const toggle = original.cloneNode(true);
    original.parentNode.replaceChild(toggle, original);

    toggle.addEventListener('click', () => {
      const body = toggle.closest('.helper-cards-general__card-body');
      const hidden = body?.querySelector('.hidden-content');
      const icons = body?.querySelector('.helper-cards-general__icons');

      if (!hidden) return;

      const isExpanded = hidden.classList.toggle('hidden-content--visible');
      toggle.classList.toggle('hidden-content--active', isExpanded);
      toggle.innerText = isExpanded ? toggle.dataset.readlesstext : toggle.dataset.readmoretext;

      if (icons) {
        icons.classList.toggle('icons--visible', isExpanded);
      }
    });
  });

  // Filter tab switching (also exposed globally for inline onclick)
  window.toggleGroup = (button, targetId) => {
    const target = document.getElementById(targetId);
    if (!target) return;

    // Deactivate all buttons and groups within this block
    block.querySelectorAll('.helper-cards-general__filter-button').forEach((btn) => {
      btn.classList.remove('active');
    });
    block.querySelectorAll('.helper-cards-general__group-wrapper').forEach((group) => {
      group.classList.remove('active');
    });

    // Activate selected
    target.classList.add('active');
    button.classList.add('active');
  };
}
